export const API_URLS = {
  tour: "tour",
  utilityCosts: "utility-costs",
  chemicalLibrary: "chemical-library",
  chemicalUsage: "usage",
  fileUpload: "uploadfile/?FTNorm=false",
  executeCleaning: "cleaning_effectiveness",
  executeCleaningStatus: "cleaning_effectiveness/status",
  cips: "cips",
  token: "token",
  uploadCips: "cips",
  cleanedData: "cleanedData",
  plantDetails: "details",
  fouling: "fouling",
  header: "header",
  foulingType: "foulingtype",
  analysisjob: "analysisjob",
  analysisStatus: "analysis/status",
  analysis: "analysis",
  type: "type",
  plants: "plants",
  cols: "cols",
  colmapping: "colmapping",
  refcondition: "refcondition",
  visualization: "visualization",
  advancesettings: "advancesettings",
  proceedToAnalysis: "proceed_to_analysis",
  details: "details",
  state: "state",
  basePath: "/",
  acceptTC: "accept_tc",
  share: "share",
  users: "users",
  user: "user",
  accessRequest: "access-request",
  accessRequests: "access-requests",
  admin: "admin",
  bulk: "bulk",
  recurrent: "recurrent",
  rerun: "rerun",
  downloadFile: "download",
  upload: "upload",
  appendFile: "appendfile",
  report: "report",
  readiness: "readiness",
  roElements: "ro-elements",
  benchmarking: "benchmarking",
  availability: "availability",
  data: "data",
  fileSheetMapping: "file-sheet-mapping",
  columnDetect: "column-detect",
  license: "license",
  permissions: "permissions",
  assign: "assign",
  terminate: "terminate",
  exportExcel: "export-excel",
  wave: "wave",
};
